// Agrupa o formulário (GET /parametros/:escopo/formulario) nos assuntos do mapa da
// tela (H1, PO1-3259). Função pura.
//
// mapa = [{ key, titulo, descricao, blocos: [{ titulo, campos: [{ id, label, ajuda,
//           confirmarAoDesligar? }] }] }]
// → [{ key, titulo, descricao, blocos: [{ titulo, campos: [{ ...paramDoFormulario,
//       label, ajuda, confirmarAoDesligar }] }] }]
//
// O mapa casa pelo Id do catálogo (idParametro) — os nomes mudam, o Id não. Um campo
// pode casar pelo `nome` em vez do `id` (PO1-3443): serve para parâmetro criado por
// script cujo Id (IDENTITY) só existe depois de rodar em produção. Sem
// label/ajuda no mapa, usa nome/descricao do formulário. O que não está no mapa cai
// em "Outros" (criado se o mapa não tiver). Assunto/bloco sem campo visível some.
//
// Fora da tela de Parâmetros: a lista OCULTOS (nunca aparecem) e os parâmetros de
// conector, que moram só em Integrações (PO1-3261).
export const OCULTOS = ["EnviarEmail", "obcUrlAPI", "obcToken"];
export const PREFIXOS_CONECTOR = ["protheus", "esp", "sefaz", "neo"];
export const NOMES_CONECTOR = ["obcUsuario"];
export const MODULOS_CONECTOR = ["ESPIAONFE", "SEFAZCTE", "PROTHEUS", "NEOGRID"];

export const KEY_OUTROS = "outros";

function nomeDe(param) {
  return String((param && param.nome) || "");
}

export function ehParametroDeConector(param) {
  const nome = nomeDe(param);
  if (!nome) return false;
  if (NOMES_CONECTOR.indexOf(nome) !== -1) return true;
  if (PREFIXOS_CONECTOR.some((p) => nome.indexOf(p) === 0)) return true;
  const modulo = String((param && param.modulo) || "").toUpperCase();
  if (MODULOS_CONECTOR.indexOf(modulo) !== -1) return true;
  if (modulo.toLowerCase().indexOf("conector-") === 0) return true;
  return false;
}

export function ehOculto(param) {
  const nome = nomeDe(param);
  if (!nome) return true;
  if (OCULTOS.indexOf(nome) !== -1) return true;
  return ehParametroDeConector(param);
}

function campoDe(param, def) {
  return {
    ...param,
    label: (def && def.label) || param.nome,
    ajuda: (def && def.ajuda) || param.descricao || "",
    confirmarAoDesligar: !!(def && def.confirmarAoDesligar),
  };
}

export function montarAssuntos(mapa, formulario) {
  const porId = {};
  const idPorNome = {};
  (formulario || []).forEach((p) => {
    if (!p || ehOculto(p)) return;
    const id = p.idParametro;
    if (id === null || id === undefined) return;
    porId[String(id)] = p;
    const nome = nomeDe(p);
    if (nome && idPorNome[nome] === undefined) idPorNome[nome] = String(id);
  });

  const usados = {};
  const saida = [];

  (mapa || []).forEach((assunto) => {
    const blocos = [];
    (assunto.blocos || []).forEach((bloco) => {
      const campos = [];
      (bloco.campos || []).forEach((def) => {
        const chave =
          def && def.id !== undefined && def.id !== null
            ? String(def.id)
            : idPorNome[String((def && def.nome) || "")];
        const param = chave !== undefined ? porId[chave] : undefined;
        if (!param || usados[chave]) return;
        usados[chave] = true;
        campos.push(campoDe(param, def));
      });
      if (campos.length) blocos.push({ titulo: bloco.titulo, descricao: bloco.descricao, campos });
    });
    saida.push({ key: assunto.key, titulo: assunto.titulo, descricao: assunto.descricao, blocos });
  });

  const sobras = Object.keys(porId)
    .filter((id) => !usados[id])
    .map((id) => porId[id])
    .sort((a, b) => nomeDe(a).localeCompare(nomeDe(b), "pt-BR"))
    .map((p) => campoDe(p, null));

  if (sobras.length) {
    let outros = saida.find((a) => a.key === KEY_OUTROS);
    if (!outros) {
      outros = {
        key: KEY_OUTROS,
        titulo: "Outros",
        descricao: "Parâmetros que ainda não têm um assunto próprio.",
        blocos: [],
      };
      saida.push(outros);
    }
    outros.blocos.push({ titulo: "Demais parâmetros", campos: sobras });
  }

  return saida.filter((a) => a.blocos.length > 0);
}

// Contagem de alterações por assunto, para o contador do menu lateral. `alterados`
// é o mapa idParametro (String) → valor.
export function contarAlteradosPorAssunto(assuntos, alterados) {
  const ids = Object.keys(alterados || {}).map(String);
  const saida = {};
  (assuntos || []).forEach((a) => {
    let n = 0;
    a.blocos.forEach((b) => {
      b.campos.forEach((c) => {
        if (ids.indexOf(String(c.idParametro)) !== -1) n += 1;
      });
    });
    saida[a.key] = n;
  });
  return saida;
}
